import fetchProvider from "@data-access/ho-so-provider";
import baseStore from "../base-store";

export default {
  ...baseStore({
    fetchProvider,
    storeName: "hoSo",
    initStore: {},
  }),
};